<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">统计表</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>订单统计</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions"></div>
      <reg-list></reg-list>
    </el-card>
  </div>
</template>
<script>
import './store';
import RegList from './components/list';
import { mapActions } from 'vuex';

export default {
  name: 'order',
  components: {
    RegList
  },
  methods: {
    ...mapActions('order', ['listAllCoin'])
  },
  mounted() {
    this.listAllCoin();
  }
};
</script>

<style lang="less" scoped></style>
